import script from "./BaseLottie.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseLottie.vue?vue&type=script&setup=true&lang=ts"

import "./BaseLottie.vue?vue&type=style&index=0&id=33185d83&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33185d83"]])

export default __exports__